import { useGamePlay } from "@/src/ducks/gamePlay";
import { useUser } from "@/src/ducks/user";

export default function ReviewPreview() {
  const { gameEnded, playingWhite, opponent } = useGamePlay();
  const { displayName } = useUser();

  return (
    <div className="flex flex-col items-center w-full h-full p-4 bg-gray-50">
      <div className="flex space-x-3 font-semibold">
        <div className="p-1">{opponent.username}</div>
        <div className="p-1">{displayName}</div>
      </div>
    </div>
  );
}
